import React from 'react';
import Marquee from 'react-fast-marquee';

import { useLayoutContext } from '@ott/layout-context';

import FadeIn from 'src/components/elements/FadeIn';
import GradientButton from 'src/components/elements/GradientButton';

import metrics from 'src/utility/metrics';

import { APP_URL } from '../../constants';
import { PAYMENT_OPTIONS } from './constants';

import styles from './PaymentOptions.scss';

const PaymentOptions = () => {
  const { isDesktop } = useLayoutContext();

  const downloadClick = (event) => {
    event.preventDefault();
    metrics('SOLAR_LANDING_INSTALL_BUTTON', { trigger: 'payment options block' });
    window.open(APP_URL);
  };

  return (
    <div className={styles.paymentOptions}>
      <div className={styles.title}>
        <FadeIn className={styles.title}>
          <span>Multi-payment</span>
        </FadeIn>
        <FadeIn className={styles.titleThin} delay={1}>
          <span>options</span>
        </FadeIn>
      </div>

      <FadeIn className={styles.description} delay={1.5}>
        <span>Pays, cards, and crypto accepted</span>
      </FadeIn>

      <Marquee className={styles.marquee} gradient={false} speed={isDesktop ? 20 : 23}>
        {PAYMENT_OPTIONS.map((option) => (
          <img
            key={option.id}
            className={styles.paymentOption}
            src={option.src}
            alt="payment-option"
          />
        ))}
      </Marquee>

      {!isDesktop && (
        <GradientButton
          className={styles.downloadButton}
          darkGradient={true}
          onClick={downloadClick}
        >
          Download app
        </GradientButton>
      )}
    </div>
  );
};

export default PaymentOptions;
